import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import AddIcon from "@material-ui/icons/Add";
import classNames from "classnames";
import { ReactNode } from "react";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: `${theme.spacing(1)}px 0`,
    justifyContent: "flex-start",
    fontWeight: 500,
    fontSize: "1rem",
    textTransform: "none"
  }
}));

type Props = {
  onClick: () => void;
  children: ReactNode;
  className?: string;
  disabled?: boolean;
};

export default function AddButton({
  onClick,
  children,
  className,
  disabled = false
}: Props) {
  const classes = useStyles();

  return (
    <Button
      type="button"
      variant="text"
      color="primary"
      onClick={onClick}
      className={classNames(classes.root, className)}
      startIcon={<AddIcon fontSize="medium" />}
      disabled={disabled}
    >
      {children}
    </Button>
  );
}
